import script from "./anchor.vue?vue&type=script&setup=true&name=containerBox&lang=js"
export * from "./anchor.vue?vue&type=script&setup=true&name=containerBox&lang=js"

import "./anchor.vue?vue&type=style&index=0&id=598880fa&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598880fa"]])

export default __exports__